module.exports = __webpack_public_path__ + "media/angular-engine/app/guest/resources/bullet-purple-4b8953f9db000cdd7c1391af4d6f2c1a.svg";